import { BarChart3, CalendarCheck2, Clock, Target } from "lucide-react";

import type { AuthLayoutProps } from "../../../components/layout/auth-layout/auth-layout.tsx";
import styles from "./sqe-login-page.module.css";

/** Shared SQE presentation for every public authentication page. */
export const SQE_AUTH_LAYOUT_PROPS = {
  variant: "sqe",
  brandLogoAlt: "SQE Labs",
  brandLogoContent: (
    <img
      className={styles.fullWordmark}
      src="/assets/sqe-login/sqe_logo.svg"
      alt="SQE Labs"
    />
  ),
  brandHeading: (
    <>
      Welcome to <span className={styles.headingSqe}>SQE</span>
      <span className={styles.headingLabs}> Labs</span>
    </>
  ),
  brandSubheading:
    "Your unified employee experience — attendance, timesheets, leaves, projects, and more, all in one place.",
  copyrightText: `© ${new Date().getFullYear()} SQE Labs. All rights reserved.`,
  features: [
    { icon: Clock, label: "Smart Attendance" },
    { icon: CalendarCheck2, label: "Leave Planning" },
    { icon: BarChart3, label: "Team Insights" },
    { icon: Target, label: "Performance Reviews" },
  ],
  photos: [
    { caption: "Sports Fest", year: "March 2025", src: "/assets/sqe-login/Sports_Fest.jpg" },
    { caption: "Team Outing", year: "April 2024", src: "/assets/sqe-login/Team_Outing.jpeg" },
    { caption: "Diwali Celebration Office", year: "October 2025", src: "/assets/sqe-login/Diwali_Celebration.jpg" },
    { caption: "Award Ceremony", year: "September 2024", src: "/assets/sqe-login/Award_Ceremony.jpeg" },
    { caption: "Team Party", year: "December 2025", src: "/assets/sqe-login/Team_Party.jpeg" },
    { caption: "Rafting Rishikesh", year: "April 2025", src: "/assets/sqe-login/Rafting.jpeg" },
    { caption: "Independence Day Celebration", year: "August 2026", src: "/assets/sqe-login/Independence_Day_Celebration.jpg" },
    { caption: "Birthday Celebration", year: "September 2026", src: "/assets/sqe-login/Birthday_Celebration.jpg" },
    { caption: "Teej Celebration", year: "August 2026", src: "/assets/sqe-login/Teej_Celebration.jpg" },
  ],
  whatsNew: [
    { tag: "live", text: "Smart timesheet drafting now available" },
  ],
} satisfies Partial<AuthLayoutProps>;
